export default "__VITE_ASSET__kUjfYqbv__"